import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import { SET_EDITOR_ACCORDION_MENU_ITEMS, SET_IS_ACCORDION_MENU_OPEN, SET_IS_CHANGING_ACTION } from './mutations';

import { setSideBarState } from '../selectedNode/actions';

const buildActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setEditorAccordionMenuItems = buildActionObject('setEditorAccordionMenuItems');
export const setIsEditorAccordionMenuOpen = buildActionObject('setIsEditorAccordionMenuOpen');
export const setIsChangingAction = buildActionObject('setIsChangingAction');

const actions = {
	...StoreModuleService.createDefaultActions(),

	[setEditorAccordionMenuItems.action]({ commit }, payload) {
		commit(SET_EDITOR_ACCORDION_MENU_ITEMS, payload);
	},
	async [setIsEditorAccordionMenuOpen.action]({ commit, dispatch }, payload) {
		await dispatch(setSideBarState.fullPath, { sideBarState: 'app-select-width' }, { root: true });
		commit(SET_IS_ACCORDION_MENU_OPEN, payload);
	},
	async [setIsChangingAction.action]({ commit, dispatch }, payload) {
		await dispatch(setIsEditorAccordionMenuOpen.action, payload);
		commit(SET_IS_CHANGING_ACTION, payload);
	},
};

export default actions;
